export default __webpack_public_path__ + "static/media/12.2a2245ef.jpg";